import React, { useContext, useEffect, useRef } from "react";
import { useAccessibility } from "../../../hooks/useAccessibility";
import { store } from "../../Store";
import { Icon } from "@iconify/react/dist/iconify.js";
import { NotificationButton } from "./notification-button";
import { LangButton } from "../../language/lang-button";
import { QuickLangButton } from "./QuickLangButton";


/**
 * Renderiza las acciones rápidas disponibles en el encabezado.
 *
 * Incluye:
 * - Botón para abrir y cerrar el panel de accesibilidad.
 * - Botón de notificaciones.
 * - Selector rápido de idioma.
 *
 * Además, registra la referencia del botón de accesibilidad en el estado global
 * para facilitar la gestión y restauración del foco cuando se interactúa con
 * el panel de accesibilidad.
 *
 * @param {Object} props - Propiedades del componente.
 * @param {Object} props.textosInterfaz - Textos utilizados en la interfaz.
 * @param {Function} props.cerrarVentana - Función que permite cerrar la ventana o panel contenedor desde los componentes hijos.
 *
 * @returns {JSX.Element} HeaderQuickActions
 */
export const HeaderQuickActions = ({ textosInterfaz, cerrarVentana }) => {
    const globalState = useContext(store);
    const accessibility = useAccessibility();
    const accessibilityButtonRef = useRef(null);

    /*Asigna el botón que abre las opciones de accesibilidad */
    useEffect(() => {
        if (accessibilityButtonRef.current) {
            globalState.dispatch({
                type: "CHANGE",
                path: "accessibility.triggerButton",
                value: accessibilityButtonRef,
            });
        }
    }, [accessibilityButtonRef]);
    return (
        <ul className="header-quick-actions d-flex">
            <li>
                <button
                    ref={accessibilityButtonRef}
                    aria-expanded={accessibility.state.visible}
                    aria-label={textosInterfaz?.button_accesibility_description}
                    className={`focusable-red icon-button`}
                    onClick={() => {
                        accessibility.setVisible(!accessibility?.state?.visible)
                        cerrarVentana && cerrarVentana()
                    }}
                >
                    <Icon
                        icon="la:universal-access"
                        width="30" height="30"
                    />
                </button>
            </li>
            <NotificationButton />
            <li className="mr-2">
                <QuickLangButton cerrarVentana={cerrarVentana} />
            </li>
        </ul>
    )
}